export enum ColumnNames {
  zone = 'zone',
  result = 'result',
  zoneReference = 'zoneReference',
  period = 'period',
  site = 'site'
}
